import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  authStatusSelector,
  authTokenSelector,
  qrcTokenSelector,
  initializeQrcFromSessionStorage,
} from "../services/redux/slices/authSlice";
import { ROUTES } from "./routerConfig";
import LoadingSpinner from "../components/common/LoadingSpinner";

// Guards the Raise Request / View Tickets / Ticket Details pages so they work both for a
// normally logged-in borrower AND for a pre-login visitor who verified themselves via the
// public Help Center OTP flow (qrcToken set from the state-checkpoint API response).
const QrcRoutes = () => {
  const dispatch = useDispatch();
  const authStatus = useSelector(authStatusSelector);
  const token = useSelector(authTokenSelector);
  const qrcToken = useSelector(qrcTokenSelector);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // qrcToken isn't part of the redux-persist whitelist (see authSlice/store) — restore
    // it from sessionStorage on a hard refresh, same pattern useAuth() uses for `token`.
    if (!qrcToken) {
      dispatch(initializeQrcFromSessionStorage());
    }
    const timer = setTimeout(() => setIsInitialized(true), 500);
    return () => clearTimeout(timer);
  }, [dispatch, qrcToken]);

  const isAuthenticated = authStatus && !!token;
  const isQrcVerified = !!qrcToken;

  if (!isInitialized) {
    return <LoadingSpinner message="Checking authentication..." />;
  }

  return isAuthenticated || isQrcVerified ? (
    <Outlet />
  ) : (
    <Navigate to={ROUTES.HelpCenter.locationPath} replace />
  );
};

export default QrcRoutes;
